import { Header } from '../../../../pricing-simulator/types/generic-table.model';

/* Reassigning the boolean value in the table state */
export default function getUpdatedDataForDropdown(
  data: any,
  columnMetadata: Header,
  newVal: boolean
) {
  data.parent.data[columnMetadata.parent.parent_field] = newVal;
  return {
    ...data.parent.data
  };
}

export function getUpdatedDataForPhRecommendation(
  data: any,
  columnMetadata: Header,
  newVal: boolean
) {
   if( data.parent.data.is_ph_recommended===true){
      data.parent.data[columnMetadata.parent.parent_field] =
      data.parent.data.is_ph_recommended===true && newVal ? 1 : 0;
      return {
        ...data.parent.data
      };
  }else{
    return {
      ...data.parent.data
    };
  }
}
